import { connect } from 'react-redux';
import Request from '../../../views/Personnel/Letter/Request.letter.view';
import { getRequest } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetRequest: payload => dispatch(getRequest(payload)),
  };
}

export default connect(null, mapDispatchToProps)(Request);
